import React from 'react';

import { Box, Image, Link } from '@chakra-ui/react';

import HrisPlugin from 'assets/assetsV1/illustrations/HRISPlugin.png';

import { contactEmail } from 'constants/ProjectConstants';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { StepCard } from '../commonComponents';

const UninstallSection = () => (
  <StepCard
    title="Un-Installation Step"
    rightComp={
      <Box border="1px solid" borderColor="feedback.E7DAFF" borderRadius="8px" overflow="hidden" width="45%">
        <Image src={HrisPlugin} objectFit="cover" width="100%" height="100%" />
      </Box>
    }
  >
    <Box>
      <TextBodyMedium>
        Please email to{' '}
        <Link display="inline-block" href={`mailto:${contactEmail}`} color="#0D819F">
          {contactEmail}
        </Link>{' '}
        to unlink the associated HRIS account
      </TextBodyMedium>
    </Box>
  </StepCard>
);
export { UninstallSection };
